/* Pat Kay — live cart: add-to-cart / buy-it-now buttons, icon count, cart takeover contents.
   Uses Shopify's AJAX cart API (/cart.js, /cart/add.js, /cart/change.js). */

(function () {
  // Conversion test 2026-07-23: checkout-first CTAs. The primary button (section label,
  // e.g. "Get my Tokyo guide") goes straight to checkout; the secondary becomes "Add to
  // cart". Set to false to restore the original add-first behavior — markup is untouched.
  var CHECKOUT_FIRST = true;
  if (CHECKOUT_FIRST) {
    var addBtns = Array.prototype.slice.call(document.querySelectorAll('[data-pk-add]'));
    var buyBtns = Array.prototype.slice.call(document.querySelectorAll('[data-pk-buy]'));
    addBtns.forEach(function (b) {
      var id = b.getAttribute('data-pk-add');
      b.removeAttribute('data-pk-add');
      b.setAttribute('data-pk-buy', id);
      if (b.textContent.trim() === 'Add to cart') b.textContent = 'Buy it now';
    });
    buyBtns.forEach(function (b) {
      var id = b.getAttribute('data-pk-buy');
      b.removeAttribute('data-pk-buy');
      b.setAttribute('data-pk-add', id);
      b.textContent = 'Add to cart';
    });
  }

  function formatMoney(cents) {
    var n = cents / 100;
    var opts = cents % 100 === 0
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return '$' + n.toLocaleString('en-US', opts);
  }

  function discountName(title) {
    // Code discounts surface the code itself as the title; anything long/spacey is an
    // internal admin title — show a neutral label instead.
    return title && title.length <= 24 && title.indexOf(' ') === -1 ? title : 'Discount';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateBadge(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<h2 class="u-title">There\'s nothing in here</h2>' +
        '<a class="u-btn" href="/collections/all">Browse the store</a>';
      return;
    }

    var html = '<div class="u-cart-lines">';
    cart.items.forEach(function (item, i) {
      var img = item.image
        ? '<a href="' + item.url + '"><img src="' + item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=160" alt="" loading="lazy"></a>'
        : '';
      var discounted = item.final_line_price < item.original_line_price;
      var priceHtml = discounted
        ? '<s>' + formatMoney(item.original_line_price) + '</s> ' + formatMoney(item.final_line_price)
        : formatMoney(item.final_line_price);
      var discountLabel = '';
      if (discounted) {
        var title = (item.discounts && item.discounts[0] && item.discounts[0].title) || '';
        discountLabel = '<div class="u-cart-line-discount">' + discountName(title) +
          ' · −' + formatMoney(item.original_line_price - item.final_line_price) + '</div>';
      }
      html +=
        '<div class="u-cart-line">' +
          '<div class="u-cart-line-img">' + img + '</div>' +
          '<div class="u-cart-line-main">' +
            '<div class="u-cart-line-title"><a href="' + item.url + '">' + item.product_title + '</a></div>' +
            discountLabel +
            '<div class="u-cart-line-controls">' +
              // Digital products: qty is always 1, so no increase control. The decrease
              // control only appears on legacy lines that somehow hold more than one.
              (item.quantity > 1
                ? '<button type="button" data-line-qty="' + (i + 1) + ':' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>'
                : '') +
              '<button type="button" class="u-cart-remove" data-line-qty="' + (i + 1) + ':0">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="u-cart-line-price">' + priceHtml + '</div>' +
        '</div>';
    });
    html += '</div>';
    if (cart.original_total_price > cart.total_price) {
      html += '<div class="u-cart-discount-row"><span>Discount</span><span>−' +
        formatMoney(cart.original_total_price - cart.total_price) + '</span></div>';
    }
    html +=
      '<div class="u-cart-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<p class="u-cart-note">All items should be received in your inbox within minutes, if not seconds.</p>' +
      '<a class="u-btn" href="/checkout">Checkout</a>';
    body.innerHTML = html;
  }

  function refresh() {
    return getCart().then(function (cart) {
      updateBadge(cart);
      renderCart(cart);
      return cart;
    });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function openCartTakeover() {
    document.body.classList.remove('search-open');
    document.body.classList.add('cart-open');
    var o = document.querySelector('.u-overlay.cart');
    if (o) o.setAttribute('aria-hidden', 'false');
  }

  function setLoading(btn, on) {
    btn.classList.toggle('btn-loading', on);
    btn.disabled = on;
  }

  // Add to cart / Buy it now — buttons grey out and spin until the cart call settles.
  // Digital products: if the variant is already in the cart, don't add a duplicate —
  // just open the cart takeover.
  document.querySelectorAll('[data-pk-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-pk-add');
      if (!id || btn.disabled) return;
      setLoading(btn, true);
      getCart()
        .then(function (cart) {
          var inCart = cart.items.some(function (item) { return item.variant_id === Number(id); });
          return inCart ? cart : addToCart(id).then(refresh);
        })
        .then(function () {
          setLoading(btn, false);
          openCartTakeover();
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  });
  document.querySelectorAll('[data-pk-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-pk-buy');
      if (!id || btn.disabled) return;
      setLoading(btn, true);
      getCart()
        .then(function (cart) {
          var inCart = cart.items.some(function (item) { return item.variant_id === Number(id); });
          return inCart ? cart : addToCart(id);
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  });

  // Quantity / remove controls inside the cart takeover (delegated — content re-renders)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (!btn) return;
    var parts = btn.getAttribute('data-line-qty').split(':');
    changeLine(Number(parts[0]), Math.max(0, Number(parts[1]))).then(function () { refresh(); });
  });

  refresh();
})();
